import Logo from "CrombieLogo.png";
import {
  Col,
  Container,
  Dropdown,
  Form,
  FormControl,
  Nav,
  Navbar,
  Row
} from "react-bootstrap";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Contents from "Contents";
import Home from "Home";
import Search from "Search";
import Examples from "Examples";
import Guides from "Guides";
import Developers from "Developers";
import NotFound from "NotFound";
import { useState } from "react";

const App: React.FC = () => {
  const [menuOpened, setMenuOpened] = useState(false);
  return (
    <div className='vh-100 d-flex flex-column position-relative'>
      <Navbar bg='dark' variant='dark'>
        <Navbar.Brand href='/'>
          <img
            alt=''
            height={30}
            src={Logo}
            className='d-inline-block align-top mr-2'
          />{" "}
          Crombie docs
        </Navbar.Brand>
        <button
          onClick={() => setMenuOpened(!menuOpened)}
          className='btn btn-dark ml-auto navbar-menu-buttton'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 30 30'
            width='30'
            stroke='white'
            height='30'
            focusable='false'>
            <title>Menu</title>
            <path
              stroke='white'
              strokeWidth='2'
              strokeLinecap='round'
              strokeMiterlimit='10'
              d='M4 7h22M4 15h22M4 23h22'></path>
          </svg>
        </button>
      </Navbar>
      <Container
        fluid
        className={`d-flex flex-fill ${
          menuOpened ? "overflow-hidden" : "overflow-auto"
        }`}>
        <Row className='mh-100 vw-100'>
          <Col
            md={12}
            className={`bg-light h-100 overflow-auto sidebar ${
              menuOpened ? "opened" : ""
            }`}>
            <Form action='/search' className='my-3'>
              <FormControl name='query' />
            </Form>
            <Dropdown.Divider />
            <Nav.Item>Guías</Nav.Item>
            {Guides.map(Guide => (
              <Nav.Link key={Guide.route} href={`/guide/${Guide.route}`}>
                {Guide.title}
              </Nav.Link>
            ))}
            <Dropdown.Divider />
            <Nav.Item>Contenidos</Nav.Item>
            {Contents.map(Content => (
              <Nav.Link key={Content.route} href={`/content/${Content.route}`}>
                {Content.title}
              </Nav.Link>
            ))}
            <Dropdown.Divider />
            <Nav.Item>Ejemplos</Nav.Item>
            {Examples.map(Example => (
              <Nav.Link key={Example.route} href={`/example/${Example.route}`}>
                {Example.title}
              </Nav.Link>
            ))}
            <Dropdown.Divider />
            <Nav.Item>Desarrolladores</Nav.Item>
            {Developers.map(Developer => (
              <Nav.Link
                key={Developer.route}
                href={`/developer/${Developer.route}`}>
                {Developer.title}
              </Nav.Link>
            ))}
          </Col>
          <Col xs id={"content"} className='h-100 overflow-auto'>
            <BrowserRouter>
              <Row className='h-100'>
                <Switch>
                  <Route exact path='/'>
                    <Home />
                  </Route>
                  <Route path='/search'>
                    <Search />
                  </Route>
                  {Contents.map(Content => (
                    <Route
                      key={Content.route}
                      path={`/content/${Content.route}`}>
                      <Content.Component />
                    </Route>
                  ))}
                  {Examples.map(Example => (
                    <Route
                      key={Example.route}
                      path={`/example/${Example.route}`}>
                      <Example.Component />
                    </Route>
                  ))}
                  {Guides.map(Guide => (
                    <Route key={Guide.route} path={`/guide/${Guide.route}`}>
                      <Guide.Component />
                    </Route>
                  ))}
                  {Developers.map(Developer => (
                    <Route
                      key={Developer.route}
                      path={`/developer/${Developer.route}`}>
                      <Developer.Component />
                    </Route>
                  ))}
                  <Route>
                    <NotFound />
                  </Route>
                </Switch>
              </Row>
            </BrowserRouter>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default App;
